import Api from "./Api";

export default class FraudParameterApi extends Api {
    constructor(){
        super(process.env.REACT_APP_FRAUD_PARAMETER_ENDPOINT);
    }
}